import styles from 'src/components/GroupHoverCard/GroupHoverCard.module.scss';
import { GroupShortInformation } from 'src/api/endpoints/students';
import * as HoverCard from '@radix-ui/react-hover-card';
import React, { FC, ReactElement } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

export type GroupHoverCardProps = {
    group: GroupShortInformation;
    branch: string | number;
    // Default 14px
    fontSize?: string | number;
};

export const GroupHoverCard: FC<GroupHoverCardProps> = (
    props: GroupHoverCardProps
): ReactElement => {
    const { group, branch, fontSize = '1em' } = props;

    return (
        <HoverCard.Root openDelay={100} closeDelay={0}>
            <HoverCard.Trigger asChild>
                <Link
                    to={`/b/${branch}/groups/${group.id}`}
                    className={styles.groupHoverCardTrigger}
                    style={{
                        fontSize: fontSize,
                    }}
                >
                    {group.name}
                    <svg
                        className="external-link-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                            height: '1em',
                            width: '1em',
                            maxWidth: '20px',
                            maxHeight: '20px',
                        }}
                        viewBox="0 -960 960 960"
                    >
                        <path d="M216-144q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h264v72H216v528h528v-264h72v264q0 29.7-21.15 50.85Q773.7-144 744-144H216Zm171-192-51-51 357-357H576v-72h240v240h-72v-117L387-336Z" />
                    </svg>
                </Link>
            </HoverCard.Trigger>
            <HoverCard.Portal>
                <HoverCard.Content
                    className={styles.groupHoverCardContent}
                    sideOffset={5}
                >
                    <div>
                        <div className={styles.groupHoverCardName}>
                            {group.name}
                        </div>
                        <div className="mt-2 flex flex-row justify-content-between flex-wrap">
                            <div className="mr-4">
                                <div className="new-text-secondary">Статус</div>
                                <div
                                    className={classNames(
                                        'new-text-prime',
                                        styles.groupHoverCardStatus,
                                        'mt-1'
                                    )}
                                >
                                    {group.status.name}
                                </div>
                            </div>
                            <div>
                                <div className="new-text-secondary">
                                    Год запуска
                                </div>
                                <div className="new-text-prime mt-1">
                                    {group.launchYear}
                                </div>
                            </div>
                        </div>
                    </div>
                </HoverCard.Content>
            </HoverCard.Portal>
        </HoverCard.Root>
    );
};
